import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import Loading from './Loading';

const StyledBoxLoadingContainer = styled(Stack)(() => ({
  position: 'fixed',
  zIndex: 1101,
  top: '0px',
  left: '0px',
  height: '100%',
  width: '100%',
  '&:before': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: 'white',
    zIndex: 0,
    opacity: 0.7,
  },
}));

interface OwnProps {
  background?: string;
}

export default function LoadingCover(props: OwnProps) {
  const { background = 'transparent' } = props;
  return (
    <StyledBoxLoadingContainer
      spacing={10}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        background,
      }}
    >
      <Loading />
    </StyledBoxLoadingContainer>
  );
}
